export default __webpack_public_path__ + "static/media/indexxGrey.cc11e898.png";